import { useRouter } from "next/router";

// TODO: Implement a custom error page
export default function ErrorPage() {
  const router = useRouter();
  const { error } = router.query;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-ash-100">
      <h1 className="text-3xl font-bold text-lava-600">Error Occurred</h1>
      <p className="text-lg text-ash-800 mt-4">{error || "An unknown error occurred. Please try again later."}</p>
      <button
        onClick={() => router.push(`/dashboard`)}
        className="mt-6 bg-rebolt-500 hover:bg-rebolt-700 text-white font-bold py-2 px-4 rounded-sm"
      >
        Go to Dashboard
      </button>
    </div>
  );
}
